import {ValgSortDir, ValgSortFunc, ValgSortType,} from '@valg-shared/components/table/table/valg-sort.directive';
import {CellRendererComponent} from '@valg-shared/components/table/directives/cell-component-outlet/cell-component-outlet.directive';
import {Type} from '@angular/core';
import {FilterType} from "./valg-filter-dialog/table-filter-dialog.data";
import { Observable } from 'rxjs';
export class ColumnMetadata {
  title: string = "";
  path?: string;
  childPath?: string;
  searchable?: boolean;
  disable?: boolean;
  rightAligned?: boolean;
  sortDiscriminator?: string;
  sortable?: boolean;
  sortDataType?: ValgSortType;
  secondarySort?: SecondarySort
  filterable?: boolean;
  filter?: Filter;
  width?: number;
  // eslint-disable-next-line
  class?: string;
  hoverText?: string | ((row: any) => string);
  presentationComponent?: Type<CellRendererComponent>;
  childPresentationComponent?: Type<CellRendererComponent>;
  // eslint-disable-next-line
  secondaryCount?: (item: any) => boolean;
  secondaryCountDescription?: string;
  countChild?: (item: any) => number;
  defaultSort?: ValgSortDir;
  sortFunction?: ValgSortFunc;
  isAccessibilityId?: boolean;
  translationPrefixKey?: string;
  dataExportTranslateFunction?: (value: any) => string;
  responsive?: string;
  responsiveRenderer?: ResponsiveRenderer;
  format?: string;
  rendererOptions?: Map<string, string | boolean>;
  defaultValue?: string;
  rowDescriptionFunction?: (value: any) => Observable<string>;
  defaultValueIfNull?: string;
  headerTooltip?: string;
  isTwoLineHeader?: boolean;
}

export interface ResponsiveRenderer {
  breakpoint: string;
  path: string;
  type?: ResponsiveRendererType;
}

export interface SecondarySort{
  path: string,
  sortFunction: ValgSortFunc;
  direction?: ValgSortDir;
}
export enum ResponsiveRendererType{
  Percentage="percentage",
  Number="number",
  String="string"
}

export interface Filter {
  filterType?: FilterType;
  filterValueConverter?: (value: any) => (any);
  filterColumnName?: string;
  filterOptions?: any[]
  filterPath?: string;
  filterOptionsSortFunction?: (current: any, next: any) => number;
}
